<template>
  <div class="activity-box">
    <div class="activity_header combination_bg">
      <div class="cart_nav"></div>
    </div>
    <div
      class="list-box"
      :style="{ 'z-index': listZindex }"
      @touchstart="touchStart"
    >
      <div class="list-item" v-for="(item, index) in goodsList" :key="index">
        <div
          class="group-bottom acea-row row-between"
          @click="toGroupDeatil(item)"
        >
          <div class="group-bottom-left">
            <div class="img acea-row row-center row-middle relative">
              <div v-show="item.stock - item.sales <= 0" class="sellOut">
                已售罄
              </div>
              <!--              <easy-loadimage :image-src="item.imageUrl" width="240rpx" height="240rpx" radius="16rpx"></easy-loadimage>-->
              <img :src="item.pictures[0]" />
            </div>
          </div>
          <div class="group-bottom-right acea-row row-column row-between">
            <div class="right-top">
              <div class="title line2">{{ item.title }}</div>
              <div class="pink acea-row">
                <div class="people">{{ item.people }}人团</div>
                <div class="groupNum">已拼{{ item.totalActivityBegin }}份</div>
              </div>
            </div>
            <div class="right-bottom acea-row row-between">
              <div class="price">
                <div class="pinkNum">
                  <span class="pinkNum-title">拼团价</span>
                  <span class="price-box semiBold">
                    <span class="icon">￥</span>
                    <span class="big-num">{{
                      priceArr(item.price)[0] || 0
                    }}</span>
                    <span>.</span>
                    <span class="small-num">{{
                      priceArr(item.price)[1] || 0
                    }}</span>
                  </span>
                </div>
                <!--                <div class="num regular num-icon">￥{{ item.price }}</div>-->
              </div>
              <div class="btnBox">
                <div class="btn">参与拼团</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="goodsList.length == 0">
        <div class="empty-box">
          <img src="~@assets/images/noActivity.png" alt="" />
          <div class="text">暂无拼团商品</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { findGroupbugList } from "@/api/activity";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["userInfo"]),
    priceArr() {
      return function (price) {
        if (price == null || price === "") {
          return ["", ""];
        }
        const priceStr = price.toString();
        return priceStr.includes(".") ? priceStr.split(".") : [priceStr, "00"];
      };
    },
  },
  data() {
    return {
      backgroundColor: "transparent",
      isBackgroundColor: false,
      listZindex: 99,
      where: {
        page: 1,
        limit: 10,
        merId: "",
      },
      loadend: false,
      loading: false,
      loadTitle: "加载更多",
      goodsList: [],
      merId: 0, //商户id
      title: "拼团列表",
    };
  },
  mounted() {
    this.getGroupList();
  },
  onPageScroll(object) {
    if (object.scrollTop > 200) {
      this.pageScrollStatus = true;
    } else if (object.scrollTop < 200) {
      this.pageScrollStatus = false;
    }
    this.$emit("scroll");
  },
  methods: {
    //拼团商品列表
    getGroupList() {
      if (this.loadend) return;
      if (this.loading) return;
      this.loading = true;
      if (this.userInfo.shopId != 0) {
        findGroupbugList(this.userInfo.shopId)
          .then((res) => {
            console.info(res);
            this.goodsList = res.result || [];
            this.loadend = true;
            this.loading = false;
            this.loadTitle = this.loadend ? "没有更多内容啦~" : "加载更多";
          })
          .catch((err) => {
            this.loading = false;
            this.loadTitle = "加载更多";
            console.error(err);
          });
      }
    },
    //to拼团详情
    toGroupDeatil(item) {
      this.$router.push({ path: `/groupbuy/detail/${item.id}` });
    },
    touchStart() {
      this.getGroupList();
    },
    onReachBottom() {
      this.where.page++;
      this.getGroupList();
    },
    onPullDownRefresh() {
      this.where.page = 1;
      this.goodsList = [];
      this.getGroupList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@assets/css/activity.scss";
.combination_bg {
  background-image: url("~@assets/images/group_list_bg.png");
}
.price-box {
  color: #e93323;
  font-weight: 600;
  .icon {
    font-size: 12px;
  }
  .big-num {
    font-size: 20px;
  }
  .small-num {
    font-size: 12px;
  }
}

.num-icon,
.icon-num {
  font-size: 12px !important;
  line-height: 16px !important;
  margin-top: 6px !important;
}

.empty-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 30px;

  .empty-img {
    width: 220px;
    height: 180px;
  }

  .text {
    font-size: 13px;
    color: #999;
  }
}
</style>
